// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'; //vuex
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'mint-ui/lib/style.css'
import Mint from'mint-ui'
Vue.use(ElementUI);
Vue.use(Mint);
Vue.config.productionTip = false
import Scroll from "vue-slim-better-scroll";
Vue.use(Scroll)
import fyInput from "@/components/form/fyInput";
Vue.component("fyInput", fyInput)
// import {Toast } from "vant";
// Vue.component("Toast", [Toast.name])

//px2rem
import 'lib-flexible'
//全局挂载Api
import {
  $Api
} from '@/api/api';
Vue.prototype.$Api = $Api

// 过滤器
import {
  Filters
} from './common/filters.js'
for (let key in Filters) {
  Vue.filter(key, Filters[key])
}

//全局过滤器
// 主图
Vue.filter('filtImg', function (val) {
  if (val) {
    return 'http://tangyingkeji.oss-cn-beijing.aliyuncs.com/tangyingkeji.oss-cn-beijing.aliyuncs.com' + val.split(",")[0];
    //return val.split(",")[0];
  }
})
Vue.filter('filtImgs', function (val) {
  if (val) {
    return 'http://tangyingkeji.oss-cn-beijing.aliyuncs.com/tangyingkeji.oss-cn-beijing.aliyuncs.com' + val;
    //return val;
  }
})

// 路由拦截器
router.beforeEach((to, from, next) => {
  //外部客户业务需要先走首页
  if (to.meta.widthOutAny && to.fullPath!='/outCust' && !sessionStorage.getItem("openid")) {
    next({
      path: '/outCust',
    })
  }else{
    next();
    return;
  }
  
  next();
});
router.afterEach((to, from) => {});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js